import { render } from "./SubNavigation.vue?vue&type=template&id=87668d50"
import script from "./SubNavigation.vue?vue&type=script&lang=js"
export * from "./SubNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/SubNavigation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "87668d50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('87668d50', __exports__)) {
    api.reload('87668d50', __exports__)
  }
  
  module.hot.accept("./SubNavigation.vue?vue&type=template&id=87668d50", () => {
    api.rerender('87668d50', render)
  })

}


export default __exports__